import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";
import { useParams, useNavigate } from "react-router-dom";

export default function EligibilityDisallowedScreen({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const navigate = useNavigate();

    const reviewAnswers = () => {
        if (loading) return;
        setError("");

        next({
            action: "review_answers"
        });
    };

    const {
        businessLocationSlug,
        businessTypeSlug,
    } = useParams();

    const close = async () => {
        if (loading) return;

        setError("");

        const response = await next({
            action: "close"
        });

        if (response?.flowData?.navigateToServiceList) {
            navigate(`/start-waiver/${businessLocationSlug}/${businessTypeSlug}`); 
        }
    };

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}            

            <div className="page-content warning-page">

                <div className="warning-icon warning-icon-danger"></div>

                <h2 className="warning-title">
                    Service not recommended
                </h2>

                <p className="warning-text">
                    {flowData?.eligibility?.serviceBlockMessage || ""}
                </p>

                { /* <p className="warning-text">
                    Based on your responses, you have disclosed a
                    medication, condition, or recent treatment that
                    makes this service unsafe or contraindicated at this
                    time.
                </p>

                <hr className="warning-divider" />

                <p className="warning-text">
                    Proceeding could result in serious injury or
                    complications. For your safety, this service cannot
                    be performed until the condition no longer applies
                    or you have received clearance from a qualified
                    healthcare provider.
                </p>

                <hr className="warning-divider" />

                <p className="warning-text">
                    Please contact{" "}
                    {flowContext.business?.businessName || "[BUSINESS_NAME]"}
                    {" "}or your healthcare provider for further guidance.
                </p> */ }

            </div>

            <div className="page-footer">

                <button
                    className="primary-button"
                    onClick={reviewAnswers}
                >
                    ‹&nbsp; Review Answers
                </button>

                <button
                    className="secondary-button"
                    onClick={close}
                >
                    Exit Waiver
                </button>

            </div>

        </div>
    );
}